/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".deadline[_ngcontent-%COMP%]{color:red}.center[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;position:relative;padding:10px}.left[_ngcontent-%COMP%]{position:absolute;right:0}"];
export { styles as styles };
